





















import { Component, Vue, Prop } from 'vue-property-decorator'

import ActButton from '../act-button.vue'
import IconTitle from '$components/icon-title'

@Component({
  components: {
    ActButton,
    IconTitle
  }
})
export default class CustomPop extends Vue {
  @Prop({
    required: true,
    default: {}
  }) source!: any
  handlerClick() {
    this.$emit('close')
    this.source.onBtnClick()
  }
}
